<template>
  <div class="has-text-centered">
    <div>{{ owner }}</div>
    <div class="mt-4">
      <button
        class="button"
        :class="{ 'is-success': checked }"
        @click="onChecked">
        checked
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableCellOwnerWithCheck',
  props: ['payload'],
  data () {
    return {
      owner: this.payload.owner,
      checked: false
    }
  },
  created () {
    this.$network_utils
      .getStats({
        designator: 'applicant_reviewed',
        date_from: this.$moment().format('YYYY-MM-DD 00:00:01'),
        date_to: this.$moment().format('YYYY-MM-DD 23:59:59'),
        resource_type: 'Applicant',
        resource_id: this.payload.resource_id
      })
      .then((response) => {
        this.checked = response.length > 0
      })
  },
  methods: {
    onChecked () {
      if (this.checked) {
        return
      }
      this.$network_utils.postStat({
        title: 'applicant_reviewed',
        designator: 'applicant_reviewed',
        content: `Applicant reviewed`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 4,
        resource_type: 'Applicant',
        resource_id: this.payload.resource_id
      })
      this.checked = true
    }
  }
}
</script>
